



















































import Component, { mixins } from "vue-class-component";
import AxiosMixin from "../../mixins/axiosMixin";
import { Emit } from "vue-property-decorator";
import LoadingDialog from "../common/LoadingDialog.vue";
import { CareService } from "./types";

@Component({
  components: {
    LoadingDialog
  }
})
export default class CareServiceDialog extends mixins(AxiosMixin) {
  private careServices: CareService[] = [];
  private headers = [
    {
      value: "kind_service_code",
      text: "サービスコード",
      width: "100px"
    },
    {
      value: "service_name",
      text: "サービス内容",
      width: "200px"
    },
    {
      value: "point",
      text: "単位数",
      width: "80px"
    },
    {
      value: "select",
      text: "選択",
      width: "80px"
    }
  ];
  private yearmonth = "";
  private service_code = "";
  private service_name = "";
  private isActive = false;

  public open(yearmonth: string, service_code: string, service_name: string) {
    this.yearmonth = yearmonth;
    this.service_code = service_code;
    this.service_name = service_name;
    this.updateData();
    this.isActive = true;
  }

  private updateData() {
    this.postJsonCheck(
      window.base_url + "/api/office/care/edit/get_service",
      {
        yearmonth: this.yearmonth,
        service_code: String(this.service_code),
        service_name: this.service_name
      },
      res => {
        this.careServices = res.data.care_services;
      }
    );
  }

  private clickSelect(careService: CareService) {
    if (
      confirm(
        "「" +
          careService.service_name +
          "」を明細行に反映します。よろしいですか？"
      )
    ) {
      this.select(careService);
      this.isActive = false;
    }
  }

  private clickCancel() {
    this.isActive = false;
  }

  @Emit()
  select(careService: CareService) {
    return careService;
  }
}
